import { View, Text, StyleSheet, Platform } from 'react-native';

const DividerText = ({ text = 'or continue with' }) => {
  return (
    <View style={styles.divider}>
      <View style={[styles.line, { backgroundColor: '#F1F1F1' }]} />
      <Text style={[styles.dividerText, { color: '#F1F1F1' }]}>{text}</Text>
      <View style={[styles.line, { backgroundColor: '#F1F1F1' }]} />
    </View>
  );
};

const styles = StyleSheet.create({
  divider: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  line: {
    flex: 1,
    height: 1,
    opacity: 0.2,
  },
  dividerText: {
    fontSize: 13,
    fontFamily: 'Public Sans',
    fontWeight: '700',
    lineHeight: 16,
    paddingHorizontal: 8,
     ...Platform.select({
          web: {
              textShadow: '2px 2px 1px rgba(0,0,0,1)',
          },
          default: {
              textShadowColor: 'rgba(0,0,0,1)',
              textShadowOffset: { width: 2, height: 2 },
              textShadowRadius: 1,
          },
      }),
  },
});

export default DividerText;
